import React from "react";
import Banner from "../components/main/Banner";
import Customers from "../components/main/Customers";
import Api from "../components/main/Api";
import SimplePayments from "../components/main/SimplePayments";
import Fraud from "../components/main/Fraud";
import TryNow from "../components/main/TryNow";

const LandingPage = () => {
  return (
    <section>
      <Banner />
      <Customers />
      <SimplePayments />
      <Api />
      <Fraud />
      <TryNow />
    </section>
  );
};

export default LandingPage;
